'use client';

import { AlertModal } from '#/components/modal/alert-modal';
import { useMounted } from '#/hooks/use-mounted';

export const AlertModalProvider = () => {
  const mounted = useMounted();

  if (!mounted) {
    return null;
  }

  return (
    <>
      <AlertModal />
    </>
  );
};
